/**
 * Thin wrapper that renders ConnectorsPage with a group-scoped service adapter.
 * Used by the `/sandbox-groups/:groupId/connectors` route.
 */

import { useMemo } from 'react';
import { useParams, Navigate } from 'react-router';
import { ConnectorsPage } from './ConnectorsPage';
import { createGroupScopedAdapter } from '@/services/connectionServiceAdapter';

export function GroupScopedConnectorsPage() {
  const { groupId } = useParams<{ groupId: string }>();
  const adapter = useMemo(() => (groupId ? createGroupScopedAdapter(groupId) : null), [groupId]);

  if (!groupId || !adapter) {
    return <Navigate to="/connectors" replace />;
  }

  return <ConnectorsPage serviceAdapter={adapter} />;
}
